module.exports = __webpack_public_path__ + "static/trey-cc6a6cdab765073e28def72cbb4cce20.jpg";